import React, { useEffect, useState } from "react";  import { generategrowthYears, generateYears } from "../utils/commonFunctions"; import autoTable from "jspdf-autotable";
    export default function GsdpTable({ formik, roleid, DistrictNamee, MandalNamee, uniqueMandalss, uniqueDistrictss, filteredData, yearss,table }) {

    const [DistrictName, setDistrictName] = useState([]); const [MandalName, setMandalname] = useState([]); const[uniqueMandals,setuniqueMandals] =useState(); const[uniqueDistricts,setuniqueDistricts] =useState();
    const years=yearss;
    console.log("years",years);
    // const years = Array.from({ length: 26 }, (_, index) => 23 + index);
    if(table === "growth" ){
        console.log("generategrowthYears().length",generategrowthYears().length);
    }
    else{
        console.log("generateYears().length",generateYears().length);

    }
    useEffect(() => {
        
        setDistrictName(DistrictNamee); setMandalname(MandalNamee); 
        setuniqueMandals(uniqueMandalss);setuniqueDistricts(uniqueDistrictss);


    }, [DistrictNamee, MandalNamee,uniqueMandalss,uniqueDistrictss]);
    
    
    return (
        <>
          <div style={{ overflowX: "auto", whiteSpace: "nowrap", maxHeight: "400vh", overflowY: "hidden" }}>        
           <table bordered hover id="my-table" className="table table-bordered custom-table table-responsive sticky-table" >
                  <thead>
           <tr className="text-center">
             <th style={{ backgroundColor: "#603913" }}  
             className="sticky-col sticky-sno" rowSpan={4}>Sector name</th>
             <th style={{ backgroundColor: "#603913" }}  className="sticky-col sticky-indust" rowSpan={4}>Industry</th>
             {(roleid === "2" ?uniqueMandals : uniqueDistricts)?.map((mandal) => ( <th key={mandal} style={{ backgroundColor: "#603913" }} colSpan={table === "growth" ? generategrowthYears().length : generateYears().length}
             > GSDP at Current Prices </th> ))}
           </tr>
           <tr> {(roleid === "2" ?uniqueMandals : uniqueDistricts)?.map((item) => ( 
            <th key={item} style={{ backgroundColor: "#603913" }} colSpan={table === "growth" ? generategrowthYears().length : generateYears().length}> {roleid === "2" ? `Mandal - ${MandalName[item]}` : `District - ${DistrictName[item]}`} </th> ))} </tr>
         <tr>
  {(roleid === "2" ? uniqueMandals : uniqueDistricts)?.map(() => 
    (table === "growth" ? generategrowthYears() : generateYears()).map((year) => (
      <th
        key={year}
        style={{ backgroundColor: "#603913", color: "#fff" }}
        className={
          year === "2022-23" &&
          ((roleid === "2"
            ? formik.values.mandal_id !== "0"
            : formik.values.district_id !== "0")
            ? "sticky-col sticky-year"
            : "")
        }
      >
        {year}
      </th>
    ))
  )}
</tr>

           <tr> 
            {(roleid === "2" ?uniqueMandals : uniqueDistricts)?.map(() => (table === "growth" ? generategrowthYears() : generateYears()).map((year, index) => ( <th key={index}  style={{ backgroundColor: "#603913", color: "white" }}   className={ year === "2022-23" && ((roleid === "2"? formik.values.mandal_id !== "0" : formik.values.district_id !== "0") ? "sticky-col sticky-year" : "") } >{index + 1}</th> )) )} </tr>
         </thead>
         <tbody>
           {(!filteredData || filteredData.length === 0) ? (
             <tr> <td className="text-center" colSpan="9"> <b style={{ color: "red" }}>Details Not Found</b> </td> </tr>
           ) : (
             (() => {
               const groupedData = {};
               const displayedKeys = new Set(); // Track unique `bs_name
               filteredData.forEach((detail) => {
                 const key = `${detail.bs_name}_${detail.sector_id}`;
                 if (!groupedData[key]) {
                   groupedData[key] = 
                   { bs_name: detail.bs_name, sector_id: detail.sector_id, 
                    sector_name: detail.sector_name,
                     mandalData: [], };
                 }
                 if ( !groupedData[key].mandalData.some( 
                  m => m.mandal_id === (roleid === "2" ? detail.mandal_id : detail.district_id) ) ) 
                 { groupedData[key].mandalData.push(detail); }
               });
              //  const groupedArray = Object.values(groupedData).sort( 
              //   (a, b) => a.sector_id - b.sector_id );
              const groupedArray = Object.values(groupedData)
            return groupedArray.map((row, i) => {
                 const showBsName = !displayedKeys.has(row.bs_name);
                 if (showBsName) displayedKeys.add(row.bs_name);
                 return (
                 <tr key={i}>
                    <td className="sticky-col sticky-sno"
                     style={{ textAlign: "left", fontWeight: "bold" }} > 
                     {showBsName ? row.bs_name : ""} </td>
                   <td className="sticky-col sticky-sector" 
                   style={{ textAlign: "left" }}> {row.sector_name} </td>
                   {row.mandalData.map((mandalDetail, idx) => 
                   years.map((year) => { 
                    const fullYearFormat = `20${year}_${parseInt(year) + 1}`; return ( <td key={`${mandalDetail.mandal_id}-${fullYearFormat}`} style={{ textAlign: "right" }} className={ fullYearFormat === "2022_23" && ((roleid === "2" ? formik.values.mandal_id !== "0" : formik.values.district_id !== "0") ? "sticky-col sticky-year" : "") } > {mandalDetail[`gsdp_price_${fullYearFormat}`] || 0} </td> ); }) )}
                 
                 
                 </tr>
              ) });
           })()
         )}
         </tbody>

         
         </table>
         </div>
        </>
    )
}